const DISMISSED_VERSION_KEY = "app-update-dismissed-version";

export function getDismissedVersion(): null | string {
  return localStorage.getItem(DISMISSED_VERSION_KEY);
}

export function setDismissedVersion(version: string): void {
  localStorage.setItem(DISMISSED_VERSION_KEY, version);
}

export function getCurrentAppVersion(): string {
  const meta = document.querySelector('meta[name="app-version"]');

  return meta?.getAttribute("content") || "unknown";
}

export async function clearAppCache(): Promise<void> {
  if (!("caches" in window)) {
    return;
  }

  try {
    const cacheNames = await caches.keys();

    await Promise.all(
      cacheNames
        .filter((name) => name.startsWith("nlc-"))
        .map((name) => caches.delete(name)),
    );
  } catch {}
}

export async function updateToNewVersion(): Promise<void> {
  await clearAppCache();
  window.location.reload();
}
